/** Parse payload đăng nhập từ API (axios đã trả `response.data`). */
export function unwrapLoginPayload(res: unknown): Record<string, unknown> {
  if (!res || typeof res !== 'object') return {}
  const r = res as Record<string, unknown>
  const inner = r.data
  if (inner && typeof inner === 'object' && !Array.isArray(inner)) {
    const d = inner as Record<string, unknown>
    if (
      d.access_token != null ||
      d.accessToken != null ||
      d.refresh_token != null ||
      d.refreshToken != null ||
      d.userInfo != null ||
      d.user != null
    ) {
      return d
    }
  }
  return r as Record<string, unknown>
}

export function extractTokensFromPayload(payload: Record<string, unknown>) {
  const accessToken = (payload.accessToken ?? payload.access_token) as string | undefined
  const refreshToken = (payload.refreshToken ?? payload.refresh_token) as string | undefined
  return { accessToken, refreshToken }
}

/** Payload `POST /auth/login`: `{ data: {...} }` hoặc phẳng. */
export function getAuthLoginData(res: unknown): Record<string, unknown> {
  if (!res || typeof res !== 'object') return {}
  const r = res as Record<string, unknown>
  const inner = r.data
  if (inner && typeof inner === 'object' && !Array.isArray(inner)) {
    return inner as Record<string, unknown>
  }
  return r
}
